var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e2) {
        reject(e2);
      }
    };
    var step = (x2) => x2.done ? resolve(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/Artboard.tsx
import { observer as observer3 } from "mobx-react";

// src/components/draw/SvgRect.tsx
import { observer } from "mobx-react";
import PropTypes2 from "prop-types";
import { useCallback } from "react";

// src/prop-types/blendMode.ts
import PropTypes from "prop-types";
var blendMode_default = PropTypes.oneOf([
  "normal",
  "darken",
  "multiply",
  "lighten",
  "dodge",
  "overlay",
  "soft-light",
  "hard-light",
  "difference",
  "exclusion",
  "hue",
  "saturation",
  "color",
  "luminosity"
]);

// src/components/helpers/roundedRectHelpers.ts
function createPathString({
  w: w2,
  h: h2,
  x: x2,
  y: y2,
  radius,
  scale
}) {
  const [xScaling, yScaling] = scale;
  const [r0, r1, r2, r3] = radius;
  const move = `M ${x2 + r0 * xScaling} ${y2} `;
  const top = `h ${w2 - (r0 * xScaling + r1 * xScaling)} q ${r1 * xScaling} 0 ${r1 * xScaling} ${r1 * yScaling} `;
  const right = `v ${h2 - (r1 * yScaling + r2 * yScaling)} q 0 ${r2 * yScaling} -${r2 * xScaling} ${r2 * yScaling} `;
  const bottom = `h -${Math.max(w2 - (r2 * xScaling + r3 * xScaling), 0)} q -${r3 * xScaling} 0 -${r3 * xScaling} -${r3 * yScaling} `;
  const left = `v -${Math.max(h2 - (r0 * yScaling + r3 * yScaling), 0)} q 0 -${r0 * yScaling} ${r0 * xScaling} -${r0 * yScaling} z`;
  return move.concat(top, right, bottom, left);
}
function capRadius([topLeft, topRight, bottomRight, bottomLeft], [width, height]) {
  const reductionFactor = Math.min(
    width / (topLeft + topRight),
    height / (topRight + bottomRight),
    width / (bottomLeft + bottomRight),
    height / (topLeft + bottomLeft),
    1
  );
  return [
    topLeft * reductionFactor,
    topRight * reductionFactor,
    bottomRight * reductionFactor,
    bottomLeft * reductionFactor
  ];
}

// src/components/draw/SvgRect.tsx
import { jsx } from "react/jsx-runtime";
function useStrokeAdjustedRectangle() {
  return useCallback(
    ({
      x: x2,
      y: y2,
      width,
      height,
      globalMatrixCache,
      strokePosition,
      strokeWidth,
      radius = [0, 0, 0, 0]
    }) => {
      let strokeAdjustedHeight = height;
      let strokeAdjustedWidth = width;
      let adjustedX = x2;
      let adjustedY = y2;
      let adjustedRadius = radius;
      if (strokePosition === "inside") {
        const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
        strokeAdjustedWidth = Math.max(
          width - strokeWidth / globalMatrixScalingX,
          width / 2
        );
        strokeAdjustedHeight = Math.max(
          height - strokeWidth / globalMatrixScalingY,
          height / 2
        );
      } else if (strokePosition === "outside") {
        const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
        strokeAdjustedWidth = Math.max(
          width + strokeWidth / globalMatrixScalingX,
          width / 2
        );
        strokeAdjustedHeight = Math.max(
          height + strokeWidth / globalMatrixScalingY,
          height / 2
        );
      }
      const widthDelta = width - strokeAdjustedWidth;
      const heightDelta = height - strokeAdjustedHeight;
      adjustedX += widthDelta / 2;
      adjustedY += heightDelta / 2;
      if (radius && (width !== strokeAdjustedWidth || height !== strokeAdjustedHeight)) {
        const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
        adjustedRadius = capRadius(radius, [
          strokeAdjustedWidth * globalMatrixScalingX,
          strokeAdjustedHeight * globalMatrixScalingY
        ]);
      }
      return {
        x: adjustedX,
        y: adjustedY,
        width: strokeAdjustedWidth,
        height: strokeAdjustedHeight,
        radius: adjustedRadius
      };
    },
    []
  );
}
var SvgRect = ({
  fill,
  fillRule,
  filter,
  globalMatrixCache,
  height,
  mixBlendMode,
  rx,
  ry,
  stroke,
  strokeDasharray,
  strokeLinecap,
  strokeLinejoin,
  strokeMiterlimit,
  strokePosition,
  strokeWidth,
  width,
  x: x2,
  y: y2
}) => {
  const strokeAdjustedRectangle = useStrokeAdjustedRectangle();
  const {
    x: adjustedX,
    y: adjustedY,
    width: strokeAdjustedWidth,
    height: strokeAdjustedHeight
  } = strokeAdjustedRectangle({
    x: x2,
    y: y2,
    width,
    height,
    globalMatrixCache,
    strokePosition,
    strokeWidth
  });
  return /* @__PURE__ */ jsx(
    "rect",
    {
      fill,
      fillRule,
      filter,
      height: strokeAdjustedHeight,
      rx,
      ry,
      stroke,
      strokeDasharray,
      strokeLinecap,
      strokeLinejoin,
      strokeMiterlimit,
      strokeWidth,
      style: {
        mixBlendMode
      },
      vectorEffect: "non-scaling-stroke",
      width: strokeAdjustedWidth,
      x: adjustedX,
      y: adjustedY
    }
  );
};
SvgRect.propTypes = {
  fill: PropTypes2.string,
  fillRule: PropTypes2.string,
  height: PropTypes2.number,
  mixBlendMode: blendMode_default,
  rx: PropTypes2.number,
  ry: PropTypes2.number,
  stroke: PropTypes2.string,
  strokeDasharray: PropTypes2.string,
  strokeLinecap: PropTypes2.string,
  strokeLinejoin: PropTypes2.string,
  strokeMiterlimit: PropTypes2.number,
  strokeWidth: PropTypes2.number,
  width: PropTypes2.number,
  x: PropTypes2.number,
  y: PropTypes2.number
};
SvgRect.defaultProps = {
  fill: "none",
  fillRule: void 0,
  height: 0,
  mixBlendMode: "normal",
  rx: 0,
  ry: 0,
  stroke: "none",
  strokeDasharray: void 0,
  strokeLinecap: void 0,
  strokeLinejoin: void 0,
  strokeMiterlimit: void 0,
  strokeWidth: 0,
  width: 0,
  x: 0,
  y: 0
};
var SvgRect_default = observer(SvgRect);

// src/components/helpers/Fills.tsx
import {
  FillUtils,
  MatrixUtils,
  PropertyClass
} from "@ballpark/design-creator";
import { useWeakImage } from "@ballpark/design-plugin-image";
import { useDesign } from "@ballpark/design-plugin-react";
import { observer as observer2 } from "mobx-react";
import React2 from "react";
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
var Fills_default = observer2(function Fills(_a) {
  var _b = _a, { Component } = _b, props = __objRest(_b, ["Component"]);
  const _a2 = props, { id, fillStyle } = _a2, otherProps = __objRest(_a2, ["id", "fillStyle"]);
  if (fillStyle === void 0)
    return null;
  const { fillRule, fills } = fillStyle;
  const fillComponents = fills.map((fill, fillIndex) => {
    const { blendMode, content, enabled } = fill;
    if (!enabled)
      return null;
    switch (content.className) {
      case PropertyClass.Color: {
        const [r2, g2, b2, a2] = content.rgbaValues;
        return /* @__PURE__ */ createElement(
          Component,
          __spreadProps(__spreadValues({}, otherProps), {
            fill: `rgba(${r2 * 255},${g2 * 255},${b2 * 255},${a2})`,
            fillRule,
            key: `fill-${fillIndex}`,
            mixBlendMode: blendMode
          })
        );
      }
      case PropertyClass.Gradient: {
        const { from, stops, type, to } = content;
        if (type === "linear") {
          const gradientId = `${id}-gradient-${fillIndex}`;
          return (
            // eslint-disable-next-line react/no-array-index-key
            /* @__PURE__ */ jsxs(React2.Fragment, { children: [
              /* @__PURE__ */ jsx2("defs", { children: /* @__PURE__ */ jsx2(
                "linearGradient",
                {
                  id: gradientId,
                  x1: from[0],
                  x2: to[0],
                  y1: from[1],
                  y2: to[1],
                  children: stops.map(({ color, stopPosition }, stopIndex) => {
                    const [r2, g2, b2, a2] = color.rgbaValues;
                    return /* @__PURE__ */ jsx2(
                      "stop",
                      {
                        offset: `${100 * stopPosition}%`,
                        stopColor: `rgba(${r2 * 255},${g2 * 255},${b2 * 255},${a2})`
                      },
                      `stop-${stopIndex}`
                    );
                  })
                }
              ) }),
              /* @__PURE__ */ createElement(
                Component,
                __spreadProps(__spreadValues({}, otherProps), {
                  fill: `url(#${gradientId})`,
                  fillRule,
                  key: `fill-${fillIndex}`,
                  mixBlendMode: blendMode
                })
              )
            ] }, `fill-${fillIndex}`)
          );
        }
        return null;
      }
      case PropertyClass.Pattern:
        if (FillUtils.isTokenInstanceFill(fill)) {
          return /* @__PURE__ */ jsx2(
            TokenFill,
            __spreadValues({
              Component,
              fill,
              fillRule
            }, otherProps),
            `fill-${fillIndex}`
          );
        }
        return /* @__PURE__ */ jsx2(
          PatternFill,
          __spreadValues({
            Component,
            fill,
            fillIndex,
            fillRule,
            id
          }, otherProps),
          `fill-${fillIndex}`
        );
      default: {
        return null;
      }
    }
  });
  return fillComponents;
});
var PatternFill = observer2(function PatternFill2(_a) {
  var _b = _a, {
    Component,
    fillIndex,
    id,
    fill,
    fillRule
  } = _b, componentProps = __objRest(_b, [
    "Component",
    "fillIndex",
    "id",
    "fill",
    "fillRule"
  ]);
  const image = useWeakImage();
  const patternId = `${id}-pattern-${fillIndex}`;
  const {
    blendMode,
    content: { source, size: patternSize }
  } = fill;
  const { getItemById, getAncestorMatrix, getBounds } = useDesign();
  const patternUrl = image.getActualUrl(source);
  if (!patternUrl)
    return null;
  const {
    itemProps: { matrix: itemMatrix }
  } = getItemById(id);
  const ancestorMatrix = getAncestorMatrix(id);
  const itemBounds = getBounds(id, true);
  if (!itemBounds)
    return null;
  const widthRatio = patternSize[0] / itemBounds.size[0];
  const heightRatio = patternSize[1] / itemBounds.size[1];
  let x2;
  let y2;
  let patternWidth;
  let patternHeight;
  let imageWidth;
  let imageHeight;
  if (widthRatio < heightRatio) {
    [imageWidth] = itemBounds.size;
    const height = imageWidth / (patternSize[0] / patternSize[1]);
    const offset = (itemBounds.size[1] - height) / 2;
    [patternWidth] = itemBounds.size;
    patternHeight = itemBounds.size[1] - offset;
    [x2] = itemBounds.point;
    y2 = itemBounds.point[1] + offset;
  } else {
    [, imageHeight] = itemBounds.size;
    const width = itemBounds.size[1] * (patternSize[0] / patternSize[1]);
    const offset = (itemBounds.size[0] - width) / 2;
    patternWidth = itemBounds.size[1] - offset;
    [, patternHeight] = itemBounds.size;
    x2 = itemBounds.point[0] + offset;
    [, y2] = itemBounds.point;
  }
  const inverseMatrix = MatrixUtils.invert(
    MatrixUtils.multiply(ancestorMatrix, itemMatrix)
  );
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx2("defs", { children: /* @__PURE__ */ jsx2(
      "pattern",
      {
        height: patternHeight,
        id: patternId,
        patternTransform: `matrix(${inverseMatrix.join(",")})`,
        patternUnits: "userSpaceOnUse",
        width: patternWidth,
        x: x2,
        y: y2,
        children: /* @__PURE__ */ jsx2("image", { height: imageHeight, href: patternUrl, width: imageWidth })
      }
    ) }),
    /* @__PURE__ */ createElement(
      Component,
      __spreadProps(__spreadValues({}, componentProps), {
        fill: `url(#${patternId})`,
        fillRule,
        key: `fill-${fillIndex}`,
        mixBlendMode: blendMode
      })
    )
  ] });
});
function TokenFill(_a) {
  var _b = _a, { Component, fill, fillRule } = _b, otherProps = __objRest(_b, ["Component", "fill", "fillRule"]);
  const { blendMode, content } = fill;
  const id = content.source;
  const { getTokens } = useDesign();
  const token = getTokens()[id];
  if (!token || token.type !== "color")
    return null;
  const [r2, g2, b2, a2] = token.value.split(",");
  return /* @__PURE__ */ jsx2(
    Component,
    __spreadProps(__spreadValues({}, otherProps), {
      fill: `rgba(${Number(r2) * 255},${Number(g2) * 255},${Number(b2) * 255},${a2})`,
      fillRule,
      mixBlendMode: blendMode
    })
  );
}

// src/components/Artboard.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var Artboard = observer3(function Artboard2({ data }) {
  const { fills, size, point } = data;
  const [x2, y2] = point;
  const [width, height] = size;
  return /* @__PURE__ */ jsx3("g", { id: "artboard", children: /* @__PURE__ */ jsx3(
    Fills_default,
    {
      Component: SvgRect_default,
      fillStyle: {
        fillRule: "nonzero",
        fills
      },
      height,
      rx: 0,
      ry: 0,
      width,
      x: x2,
      y: y2
    }
  ) });
});

// src/components/CompoundPath.tsx
import { useDesign as useDesign3 } from "@ballpark/design-plugin-react";
import { observer as observer9 } from "mobx-react";

// src/components/Path.tsx
import {
  ItemUtils,
  PathUtils,
  PointUtils as PointUtils2,
  StrokeUtils
} from "@ballpark/design-creator";
import { observer as observer8 } from "mobx-react";
import React4 from "react";

// src/components/draw/SvgPath.tsx
import { observer as observer4 } from "mobx-react";
import { jsx as jsx4 } from "react/jsx-runtime";
function SvgPath({
  d: d2,
  fill = "none",
  fillRule,
  filter,
  mixBlendMode,
  opacity,
  stroke = "none",
  strokeDasharray,
  strokeLinecap,
  strokeLinejoin,
  strokeMiterlimit,
  strokeWidth = 0
}) {
  return /* @__PURE__ */ jsx4(
    "path",
    {
      d: d2,
      fill,
      fillRule,
      filter,
      opacity,
      stroke,
      strokeDasharray,
      strokeLinecap,
      strokeLinejoin,
      strokeMiterlimit,
      strokeWidth,
      style: {
        mixBlendMode
      },
      vectorEffect: "non-scaling-stroke"
    }
  );
}
var SvgPath_default = observer4(SvgPath);

// src/components/helpers/Decoration.tsx
import {
  LineDecoration,
  MatrixUtils as MatrixUtils2,
  PointUtils
} from "@ballpark/design-creator";
import { observer as observer5 } from "mobx-react";
import { jsx as jsx5 } from "react/jsx-runtime";
var TriangleArrow = observer5(function TriangleArrow2({
  color,
  strokeWidth
}) {
  const size = strokeWidth * 5;
  return /* @__PURE__ */ jsx5(
    "path",
    {
      d: `M0 0 L${size} ${size / 2} L0 ${size} Z`,
      fill: color,
      transform: `translate(-${size}, ${-size / 2})`
    }
  );
});
var LineArrow = observer5(function LineArrow2({
  color,
  strokeWidth
}) {
  const size = strokeWidth * 4;
  const matrix = MatrixUtils2.rotate(MatrixUtils2.create(), Math.PI / 4);
  return /* @__PURE__ */ jsx5(
    "path",
    {
      d: `M -${size} 0 L0 0 L0 ${size}`,
      stroke: color,
      strokeWidth,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      transform: `matrix(${matrix.join(" ")})`
    }
  );
});
var Circle = observer5(function Circle2({
  color,
  strokeWidth
}) {
  return /* @__PURE__ */ jsx5(
    "circle",
    {
      r: strokeWidth * 2,
      stroke: color,
      strokeWidth,
      fill: "white"
    }
  );
});
var decorationByType = {
  [LineDecoration.Circle]: Circle,
  [LineDecoration.LineArrow]: LineArrow,
  [LineDecoration.None]: null,
  [LineDecoration.TriangleArrow]: TriangleArrow
};
var Decoration = observer5(function Decoration2(_a) {
  var _b = _a, {
    decoration,
    angle,
    point,
    globalMatrixCache
  } = _b, props = __objRest(_b, [
    "decoration",
    "angle",
    "point",
    "globalMatrixCache"
  ]);
  const { color, strokeWidth } = props;
  if (!color || !strokeWidth)
    return null;
  const DecorationComponent = decorationByType[decoration];
  if (!DecorationComponent)
    return null;
  const transformedPoint = PointUtils.transform(
    point,
    globalMatrixCache.matrix
  );
  const matrix = MatrixUtils2.translate(
    MatrixUtils2.rotate(
      MatrixUtils2.invert(globalMatrixCache.matrix),
      angle + globalMatrixCache.rotation,
      transformedPoint
    ),
    [transformedPoint[0], transformedPoint[1]]
  );
  return /* @__PURE__ */ jsx5("g", { transform: `matrix(${matrix.join(" ")})`, children: /* @__PURE__ */ jsx5(DecorationComponent, __spreadValues({}, props)) });
});
function getDecorationLength(decorationType, strokeWidth) {
  switch (decorationType) {
    case LineDecoration.Circle:
      return 0;
    case LineDecoration.TriangleArrow:
      return strokeWidth * 5;
    case LineDecoration.LineArrow:
      return 0;
    case LineDecoration.None:
      return 0;
    default:
      return 0;
  }
}

// src/components/helpers/Strokes.tsx
import { NumberUtils } from "@ballpark/design-creator";
import { useView } from "@ballpark/design-plugin-view";
import { observer as observer6 } from "mobx-react";
import React3 from "react";
import { createElement as createElement2 } from "react";
var Strokes = observer6(function Strokes2(_a) {
  var _b = _a, {
    Component,
    data,
    ignoreZoom,
    minIgnoreZoom
  } = _b, componentProps = __objRest(_b, [
    "Component",
    "data",
    "ignoreZoom",
    "minIgnoreZoom"
  ]);
  const view = useView();
  const { strokes, strokeStyle } = data;
  const { dashArray, miterLimit, strokeCap, strokeJoin } = strokeStyle;
  const strokeComponents = strokes.map((stroke, i2) => {
    const { color, strokePosition, width, enabled } = stroke;
    if (!enabled)
      return null;
    switch (color.className) {
      case "Color": {
        const [r2, g2, b2, a2] = color.rgbaValues;
        const strokeWidth = ignoreZoom ? width / Math.max(minIgnoreZoom || NumberUtils.EPSILON, view.zoomFactor) : width;
        return /* @__PURE__ */ createElement2(
          Component,
          __spreadProps(__spreadValues({}, componentProps), {
            key: `stroke-${i2}`,
            opacity: a2,
            stroke: `rgb(${r2 * 255},${g2 * 255},${b2 * 255})`,
            strokeDasharray: dashArray.join(","),
            strokeLinecap: strokeCap,
            strokeLinejoin: strokeJoin,
            strokeMiterlimit: miterLimit,
            strokePosition,
            strokeWidth
          })
        );
      }
      default: {
        return React3.Fragment;
      }
    }
  });
  return strokeComponents;
});

// src/components/helpers/Untransform.tsx
import { MatrixUtils as MatrixUtils3 } from "@ballpark/design-creator";
import { observer as observer7 } from "mobx-react";
import { jsx as jsx6 } from "react/jsx-runtime";
var Untransform = observer7(function Untransform2(_a) {
  var _b = _a, {
    children,
    globalMatrixCache
  } = _b, props = __objRest(_b, [
    "children",
    "globalMatrixCache"
  ]);
  return /* @__PURE__ */ jsx6(
    "g",
    __spreadProps(__spreadValues({
      transform: `matrix(${MatrixUtils3.invert(globalMatrixCache.matrix).join(
        " "
      )})`
    }, props), {
      children
    })
  );
});

// src/components/hooks/useGlobalMatrixScaling.ts
import { MatrixUtils as MatrixUtils4 } from "@ballpark/design-creator";
import { useDesign as useDesign2 } from "@ballpark/design-plugin-react";
import { computed, runInAction } from "mobx";
import { useLocalObservable } from "mobx-react";
import { useEffect } from "react";
function useGlobalMatrixCache(id) {
  const { getGlobalMatrix } = useDesign2();
  const cache = useLocalObservable(
    () => ({
      getGlobalMatrix,
      id,
      get matrix() {
        return id ? this.getGlobalMatrix(id) : MatrixUtils4.create();
      },
      get scaling() {
        return MatrixUtils4.getScaling(this.matrix);
      },
      get rotation() {
        return MatrixUtils4.getRotationAngle(this.matrix);
      },
      get translation() {
        return MatrixUtils4.getTranslation(this.matrix);
      }
    }),
    {
      matrix: computed.struct,
      scaling: computed.struct
    }
  );
  useEffect(() => {
    runInAction(() => {
      cache.id = id;
      cache.getGlobalMatrix = getGlobalMatrix;
    });
  }, [cache, id, getGlobalMatrix]);
  return cache;
}

// src/components/Path.tsx
import { jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var Path = observer8(function Path2(_a) {
  var _b = _a, {
    data,
    ignoreZoom,
    globalMatrixCache
  } = _b, props = __objRest(_b, [
    "data",
    "ignoreZoom",
    "globalMatrixCache"
  ]);
  const { d: d2, startDecoration, endDecoration } = pathElementToSVGPath(
    data,
    globalMatrixCache.matrix
  );
  const emptyGlobalMatrixCache = useGlobalMatrixCache(null);
  return /* @__PURE__ */ jsx7(Untransform, { globalMatrixCache, children: /* @__PURE__ */ jsx7(
    DPath,
    __spreadProps(__spreadValues({}, props), {
      d: d2,
      data,
      startDecoration,
      endDecoration,
      globalMatrixCache: emptyGlobalMatrixCache
    })
  ) });
});
var DPath = observer8(function DPath2({
  d: d2,
  data,
  clipPathId,
  startDecoration,
  endDecoration,
  globalMatrixCache,
  hideDecorations,
  ignoreZoom,
  minIgnoreZoom
}) {
  const { id } = data;
  return /* @__PURE__ */ jsxs2(React4.Fragment, { children: [
    clipPathId && /* @__PURE__ */ jsx7("clipPath", { id: clipPathId, children: /* @__PURE__ */ jsx7(SvgPath_default, { d: d2 }) }),
    /* @__PURE__ */ jsx7(Fills_default, { Component: SvgPath_default, fillStyle: data.fillStyle, id, d: d2 }),
    /* @__PURE__ */ jsx7(
      Strokes,
      {
        Component: DecoratedSVGPath,
        data,
        d: d2,
        globalMatrixCache,
        startDecoration,
        endDecoration,
        hideDecorations,
        ignoreZoom,
        minIgnoreZoom
      }
    )
  ] });
});
var DecoratedSVGPath = observer8(function DecoratedSvgPath(props) {
  const _a = props, {
    opacity,
    mixBlendMode,
    filter,
    stroke,
    strokeWidth,
    startDecoration,
    endDecoration,
    globalMatrixCache,
    hideDecorations
  } = _a, restProps = __objRest(_a, [
    "opacity",
    "mixBlendMode",
    "filter",
    "stroke",
    "strokeWidth",
    "startDecoration",
    "endDecoration",
    "globalMatrixCache",
    "hideDecorations"
  ]);
  const hasEndDecoration = !hideDecorations && !!endDecoration;
  const hasStartDecoration = !hideDecorations && !!startDecoration;
  if (!strokeWidth || !stroke || !hasEndDecoration && !hasStartDecoration)
    return /* @__PURE__ */ jsx7(SvgPath_default, __spreadValues({}, props));
  return /* @__PURE__ */ jsxs2("g", { opacity, style: { mixBlendMode }, filter, children: [
    /* @__PURE__ */ jsx7(SvgPath_default, __spreadValues({ stroke, strokeWidth }, restProps)),
    hasStartDecoration && /* @__PURE__ */ jsx7(
      Decoration,
      {
        decoration: startDecoration.type,
        color: stroke,
        strokeWidth,
        angle: startDecoration.angle,
        point: startDecoration.point,
        globalMatrixCache
      }
    ),
    hasEndDecoration && /* @__PURE__ */ jsx7(
      Decoration,
      {
        decoration: endDecoration.type,
        color: stroke,
        strokeWidth,
        angle: endDecoration.angle,
        point: endDecoration.point,
        globalMatrixCache
      }
    )
  ] });
});
function pathElementToSVGPath(path, matrix) {
  const startDecorationType = PathUtils.getStartDecoration(path);
  const endDecorationType = PathUtils.getEndDecoration(path);
  const stroke = ItemUtils.getStrokes(path)[0];
  const strokeWidth = stroke ? StrokeUtils.getWidth(stroke) : 0;
  const absoluteSegments = relativeToAbsoluteSegments(path.segments, matrix);
  return segmentsToDecoratedSVGPath(absoluteSegments, {
    strokeWidth,
    startDecorationType,
    endDecorationType
  });
}
function segmentsToDecoratedSVGPath(absoluteSegments, {
  startDecorationType,
  startDecorationAngle,
  endDecorationType,
  endDecorationAngle,
  closed = false,
  strokeWidth = 0
}) {
  if (absoluteSegments.length < 2)
    return { d: "" };
  const canDecorate = !closed && strokeWidth;
  if (!canDecorate) {
    return {
      d: segmentsToSVGPath(absoluteSegments, closed)
    };
  }
  let startAngle = 0;
  let endAngle = 0;
  let adjustedSegments = absoluteSegments;
  if (startDecorationType) {
    const length = getDecorationLength(startDecorationType, strokeWidth);
    ({ segments: adjustedSegments, angle: startAngle } = adjustSegmentsForDecoration(
      adjustedSegments,
      length,
      1,
      strokeWidth * 0.5
    ));
  }
  if (endDecorationType) {
    const length = getDecorationLength(endDecorationType, strokeWidth);
    ({ segments: adjustedSegments, angle: endAngle } = adjustSegmentsForDecoration(
      adjustedSegments,
      length,
      -1,
      strokeWidth * 0.5
    ));
  }
  if (adjustedSegments.length < 2) {
    return {
      d: "",
      startDecoration: startDecorationType ? {
        type: startDecorationType,
        point: absoluteSegments[0].slice(0, 2),
        angle: startDecorationAngle != null ? startDecorationAngle : getSegmentsAngle(
          absoluteSegments[absoluteSegments.length - 1],
          absoluteSegments[0]
        )
      } : void 0,
      endDecoration: endDecorationType ? {
        type: endDecorationType,
        point: absoluteSegments[absoluteSegments.length - 1].slice(
          0,
          2
        ),
        angle: endDecorationAngle != null ? endDecorationAngle : getSegmentsAngle(
          absoluteSegments[0],
          absoluteSegments[absoluteSegments.length - 1]
        )
      } : void 0
    };
  }
  const startDecoration = startDecorationType ? {
    type: startDecorationType,
    point: absoluteSegments[0].slice(0, 2),
    angle: startDecorationAngle != null ? startDecorationAngle : startAngle
  } : void 0;
  const endDecoration = endDecorationType ? {
    type: endDecorationType,
    point: absoluteSegments[absoluteSegments.length - 1].slice(
      0,
      2
    ),
    angle: endDecorationAngle != null ? endDecorationAngle : endAngle
  } : void 0;
  return {
    d: segmentsToSVGPath(adjustedSegments, closed),
    startDecoration,
    endDecoration
  };
}
function relativeToAbsoluteSegments(segments, matrix) {
  return segments.map((segment) => {
    const [x2, y2] = matrix ? PointUtils2.transform([segment[0], segment[1]], matrix) : segment;
    if (segment.length === 6) {
      const [, , x1, y1, x22, y22] = segment;
      return [
        x2,
        y2,
        // convert (x1, y1) and (x2, y2) to absolute
        x1 + x2,
        y1 + y2,
        x22 + x2,
        y22 + y2
      ];
    }
    return [x2, y2];
  });
}
function segmentsToSVGPath(segments, closed) {
  const lines = segmentsToLines(segments, closed);
  const svgLines = lines.map(([segmentA, segmentB]) => {
    const { p1, p2, p3 } = segmentsToCubicBezier(segmentA, segmentB);
    return `C${p1[0]} ${p1[1]}, ${p2[0]} ${p2[1]}, ${p3[0]} ${p3[1]}`;
  }).join(" ");
  const [x2, y2] = segments[0];
  return `M${x2} ${y2} ${svgLines} ${closed ? "Z" : ""}`;
}
function segmentsToLines(segments, closed) {
  const lines = [];
  for (let i2 = 0; i2 < segments.length - 1; i2 += 1) {
    const segmentA = segments[i2];
    const segmentB = segments[i2 + 1];
    lines.push([segmentA, segmentB]);
  }
  if (closed) {
    const segmentA = segments[segments.length - 1];
    const segmentB = segments[0];
    lines.push([segmentA, segmentB]);
  }
  return lines;
}
function segmentsToCubicBezier(segmentA, segmentB) {
  const [p0x, p0y, , , p1x, p1y] = addAnchors(segmentA);
  const [p3x, p3y, p2x, p2y] = addAnchors(segmentB);
  return {
    p0: [p0x, p0y],
    p1: [p1x, p1y],
    p2: [p2x, p2y],
    p3: [p3x, p3y]
  };
}
function addAnchors(segment) {
  if (segment.length === 6) {
    return segment;
  }
  const [x2, y2] = segment;
  return [x2, y2, x2, y2, x2, y2];
}
function getSegmentsAngle(startSegment, endSegment) {
  if (startSegment.length === 2 && endSegment.length === 2) {
    return Math.atan2(
      endSegment[1] - startSegment[1],
      endSegment[0] - startSegment[0]
    );
  }
  const startPoint = startSegment.slice(0, 2);
  const endPoint = endSegment.slice(0, 2);
  return Math.atan2(endPoint[1] - startPoint[1], endPoint[0] - startPoint[0]);
}
function interpolateBezier(start, end, t2) {
  const [p0x, p0y, , , c0x, c0y] = start;
  const [p1x, p1y, c1x, c1y] = end;
  return [
    __pow(1 - t2, 3) * p0x + 3 * __pow(1 - t2, 2) * t2 * c0x + 3 * (1 - t2) * __pow(t2, 2) * c1x + __pow(t2, 3) * p1x,
    __pow(1 - t2, 3) * p0y + 3 * __pow(1 - t2, 2) * t2 * c0y + 3 * (1 - t2) * __pow(t2, 2) * c1y + __pow(t2, 3) * p1y
  ];
}
function adjustSegmentsForDecoration(segments, length, direction = 1, overlap = 0) {
  if (!length || segments.length < 2)
    return {
      segments,
      angle: 0
    };
  const forwards = direction > 0;
  const startIndex = forwards ? 0 : segments.length - 1;
  const endIndex = forwards ? segments.length - 1 : 0;
  const target = segments[startIndex].slice(0, 2);
  function createNewSegments(i2, newSegments) {
    if (forwards) {
      const pointA2 = newSegments[0].slice(0, 2);
      const pointB2 = segments[0].slice(0, 2);
      const overlapPoint2 = PointUtils2.extend(pointB2, pointA2, -overlap);
      return {
        segments: [
          overlapPoint2,
          ...newSegments,
          ...segments.slice(i2 + newSegments.length)
        ],
        angle: getSegmentsAngle(pointA2, pointB2)
      };
    }
    const pointA = newSegments[newSegments.length - 1].slice(0, 2);
    const pointB = segments[segments.length - 1].slice(0, 2);
    const overlapPoint = PointUtils2.extend(pointB, pointA, -overlap);
    return {
      segments: [
        ...segments.slice(0, i2 + 1 - newSegments.length),
        ...newSegments,
        overlapPoint
      ],
      angle: getSegmentsAngle(pointA, pointB)
    };
  }
  for (let i2 = startIndex; i2 !== endIndex; i2 += direction) {
    const start = forwards ? segments[i2] : segments[i2 + direction];
    const end = forwards ? segments[i2 + direction] : segments[i2];
    const isLine = start.length === 2 && end.length === 2;
    if (isLine) {
      const intersections = intersectLineCircle(start, end, target, length);
      if (intersections.length) {
        return createNewSegments(i2, [intersections[0]]);
      }
    } else {
      const curveStart = addAnchors(start);
      const curveEnd = addAnchors(end);
      const [startJ, endJ, incr] = forwards ? [0, 51, 1] : [50, -1, -1];
      for (let j2 = startJ; j2 !== endJ; j2 += incr) {
        const t2 = j2 / 50;
        const point = interpolateBezier(curveStart, curveEnd, t2);
        const distance = PointUtils2.distance(point, target);
        if (distance >= length) {
          const newSegments = splitCubicCurve(curveStart, curveEnd, t2);
          const slicedSegments = forwards ? newSegments.slice(1) : newSegments.slice(0, 2);
          return createNewSegments(i2, slicedSegments);
        }
      }
    }
  }
  return {
    segments: [],
    angle: forwards ? getSegmentsAngle(
      segments[segments.length - 2],
      segments[segments.length - 1]
    ) : getSegmentsAngle(segments[1], segments[0])
  };
}
function intersectLineCircle(p1, p2, center, radius) {
  const v1 = PointUtils2.subtract(p2, p1);
  const v2 = PointUtils2.subtract(p1, center);
  const b2 = PointUtils2.dot(v1, v2) * -2;
  const c2 = 2 * PointUtils2.dot(v1, v1);
  const d2 = Math.sqrt(
    b2 * b2 - 2 * c2 * (PointUtils2.dot(v2, v2) - radius * radius)
  );
  if (Number.isNaN(d2))
    return [];
  const u1 = (b2 - d2) / c2;
  const u2 = (b2 + d2) / c2;
  const intersections = [];
  if (u1 >= 0 && u1 <= 1) {
    intersections.push(PointUtils2.add(p1, PointUtils2.multiply(v1, u1)));
  }
  if (u2 >= 0 && u2 <= 1) {
    intersections.push(PointUtils2.add(p1, PointUtils2.multiply(v1, u2)));
  }
  return intersections;
}
function splitCubicCurve(start, end, t2) {
  const [p0x, p0y, _0x, _0y, c0x, c0y] = start;
  const [p1x, p1y, c1x, c1y, _1x, _1y] = end;
  const ct = t2 - 1;
  const t22 = t2 * t2;
  const ct2 = ct * ct;
  const t3 = t22 * t2;
  const ct3 = ct2 * ct;
  const left = [
    p0x,
    p0y,
    t2 * c0x - ct * p0x,
    t2 * c0y - ct * p0y,
    t22 * c1x - 2 * t2 * ct * c0x + ct2 * p0x,
    t22 * c1y - 2 * t2 * ct * c0y + ct2 * p0y,
    t3 * p1x - 3 * t22 * ct * c1x + 3 * t2 * ct2 * c0x - ct3 * p0x,
    t3 * p1y - 3 * t22 * ct * c1y + 3 * t2 * ct2 * c0y - ct3 * p0y
  ];
  const right = [
    t3 * p1x - 3 * t22 * ct * c1x + 3 * t2 * ct2 * c0x - ct3 * p0x,
    t3 * p1y - 3 * t22 * ct * c1y + 3 * t2 * ct2 * c0y - ct3 * p0y,
    t22 * p1x - 2 * t2 * ct * c1x + ct2 * c0x,
    t22 * p1y - 2 * t2 * ct * c1y + ct2 * c0y,
    t2 * p1x - ct * c1x,
    t2 * p1y - ct * c1y,
    p1x,
    p1y
  ];
  return [
    [left[0], left[1], _0x, _0y, left[2], left[3]],
    [left[6], left[7], left[4], left[5], right[2], right[3]],
    [right[6], right[7], right[4], right[5], _1x, _1y]
  ];
}

// src/components/CompoundPath.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var CompoundPath = observer9(function CompoundPath2(props) {
  const { getItemById } = useDesign3();
  const d2 = collapseToSVGPath(props.data, getItemById);
  return /* @__PURE__ */ jsx8(DPath, __spreadProps(__spreadValues({}, props), { d: d2 }));
});
function collapseToSVGPath(item, getItemById) {
  if (item.className === "CompoundPath") {
    return item.children.map((id) => {
      const child = getItemById(id);
      return collapseToSVGPath(child, getItemById);
    }).join(" ");
  }
  return pathElementToSVGPath(item).d;
}

// src/components/Design.tsx
import { OverlayPortalProvider as OverlayPortalProvider2 } from "@ballpark/design-core";
import { PointUtils as PointUtils7 } from "@ballpark/design-creator";
import { WeakFontsProvider } from "@ballpark/design-plugin-fonts";
import { useDesign as useDesign7 } from "@ballpark/design-plugin-react";
import { WeakViewProvider, useView as useView3 } from "@ballpark/design-plugin-view";
import { useComponents as useComponents8 } from "@ballpark/design-renderer-base";
import { observer as observer28 } from "mobx-react";
import { useState } from "react";

// ../../node_modules/.store/react-shadow-virtual-1264a9c242/node_modules/react-shadow/react-shadow.esm.js
import e, { useRef as r, useEffect as t, createContext as n, forwardRef as o, useState as a, useContext as c } from "react";
import { createPortal as u } from "react-dom";
import i from "prop-types";
var l = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function s(e2, r2) {
  return e2(r2 = { exports: {} }, r2.exports), r2.exports;
}
var f = s(function(e2) {
  !function(r2) {
    var t2 = function(e3, r3, n3) {
      if (!i2(r3) || s2(r3) || f2(r3) || p2(r3) || u2(r3))
        return r3;
      var o3, a3 = 0, c3 = 0;
      if (l2(r3))
        for (o3 = [], c3 = r3.length; a3 < c3; a3++)
          o3.push(t2(e3, r3[a3], n3));
      else
        for (var d3 in o3 = {}, r3)
          Object.prototype.hasOwnProperty.call(r3, d3) && (o3[e3(d3, n3)] = t2(e3, r3[d3], n3));
      return o3;
    }, n2 = function(e3) {
      return d2(e3) ? e3 : (e3 = e3.replace(/[\-_\s]+(.)?/g, function(e4, r3) {
        return r3 ? r3.toUpperCase() : "";
      })).substr(0, 1).toLowerCase() + e3.substr(1);
    }, o2 = function(e3) {
      var r3 = n2(e3);
      return r3.substr(0, 1).toUpperCase() + r3.substr(1);
    }, a2 = function(e3, r3) {
      return function(e4, r4) {
        var t3 = (r4 = r4 || {}).separator || "_", n3 = r4.split || /(?=[A-Z])/;
        return e4.split(n3).join(t3);
      }(e3, r3).toLowerCase();
    }, c2 = Object.prototype.toString, u2 = function(e3) {
      return "function" == typeof e3;
    }, i2 = function(e3) {
      return e3 === Object(e3);
    }, l2 = function(e3) {
      return "[object Array]" == c2.call(e3);
    }, s2 = function(e3) {
      return "[object Date]" == c2.call(e3);
    }, f2 = function(e3) {
      return "[object RegExp]" == c2.call(e3);
    }, p2 = function(e3) {
      return "[object Boolean]" == c2.call(e3);
    }, d2 = function(e3) {
      return (e3 -= 0) == e3;
    }, y2 = function(e3, r3) {
      var t3 = r3 && "process" in r3 ? r3.process : r3;
      return "function" != typeof t3 ? e3 : function(r4, n3) {
        return t3(r4, e3, n3);
      };
    }, h2 = { camelize: n2, decamelize: a2, pascalize: o2, depascalize: a2, camelizeKeys: function(e3, r3) {
      return t2(y2(n2, r3), e3);
    }, decamelizeKeys: function(e3, r3) {
      return t2(y2(a2, r3), e3, r3);
    }, pascalizeKeys: function(e3, r3) {
      return t2(y2(o2, r3), e3);
    }, depascalizeKeys: function() {
      return this.decamelizeKeys.apply(this, arguments);
    } };
    e2.exports ? e2.exports = h2 : r2.humps = h2;
  }(l);
}).decamelize;
var p = s(function(e2) {
  function r2() {
    return e2.exports = r2 = Object.assign || function(e3) {
      for (var r3 = 1; r3 < arguments.length; r3++) {
        var t2 = arguments[r3];
        for (var n2 in t2)
          Object.prototype.hasOwnProperty.call(t2, n2) && (e3[n2] = t2[n2]);
      }
      return e3;
    }, r2.apply(this, arguments);
  }
  e2.exports = r2;
});
var d = function(e2) {
  if (Array.isArray(e2))
    return e2;
};
var y = function(e2, r2) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e2)) {
    var t2 = [], n2 = true, o2 = false, a2 = void 0;
    try {
      for (var c2, u2 = e2[Symbol.iterator](); !(n2 = (c2 = u2.next()).done) && (t2.push(c2.value), !r2 || t2.length !== r2); n2 = true)
        ;
    } catch (e3) {
      o2 = true, a2 = e3;
    } finally {
      try {
        n2 || null == u2.return || u2.return();
      } finally {
        if (o2)
          throw a2;
      }
    }
    return t2;
  }
};
var h = function(e2, r2) {
  (null == r2 || r2 > e2.length) && (r2 = e2.length);
  for (var t2 = 0, n2 = new Array(r2); t2 < r2; t2++)
    n2[t2] = e2[t2];
  return n2;
};
var v = function(e2, r2) {
  if (e2) {
    if ("string" == typeof e2)
      return h(e2, r2);
    var t2 = Object.prototype.toString.call(e2).slice(8, -1);
    return "Object" === t2 && e2.constructor && (t2 = e2.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(e2) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? h(e2, r2) : void 0;
  }
};
var m = function() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
};
var b = function(e2, r2) {
  return d(e2) || y(e2, r2) || v(e2, r2) || m();
};
var g = function(e2, r2) {
  if (null == e2)
    return {};
  var t2, n2, o2 = {}, a2 = Object.keys(e2);
  for (n2 = 0; n2 < a2.length; n2++)
    t2 = a2[n2], r2.indexOf(t2) >= 0 || (o2[t2] = e2[t2]);
  return o2;
};
var S = function(e2, r2) {
  if (null == e2)
    return {};
  var t2, n2, o2 = g(e2, r2);
  if (Object.getOwnPropertySymbols) {
    var a2 = Object.getOwnPropertySymbols(e2);
    for (n2 = 0; n2 < a2.length; n2++)
      t2 = a2[n2], r2.indexOf(t2) >= 0 || Object.prototype.propertyIsEnumerable.call(e2, t2) && (o2[t2] = e2[t2]);
  }
  return o2;
};
var w = n(null);
function O(e2) {
  var r2 = e2.root, t2 = e2.children;
  return u(t2, r2);
}
function j(n2) {
  var c2 = o(function(o2, c3) {
    var u2, i2, l2 = o2.mode, s2 = o2.delegatesFocus, f2 = o2.styleSheets, d2 = o2.ssr, y2 = o2.children, h2 = S(o2, ["mode", "delegatesFocus", "styleSheets", "ssr", "children"]), v2 = (i2 = r((u2 = c3) && u2.current), t(function() {
      u2 && (u2.current = i2.current);
    }, [u2]), i2), m2 = a(null), g2 = b(m2, 2), j2 = g2[0], x2 = g2[1], z = "node_".concat(l2).concat(s2);
    return t(function() {
      if (v2.current)
        try {
          if ("function" == typeof c3 && c3(v2.current), d2) {
            var e2 = v2.current.shadowRoot;
            return void x2(e2);
          }
          var r2 = v2.current.attachShadow({ mode: l2, delegatesFocus: s2 });
          f2.length > 0 && (r2.adoptedStyleSheets = f2), x2(r2);
        } catch (e3) {
          !function(e4) {
            var r3 = e4.error, t2 = e4.styleSheets, n3 = e4.root;
            switch (r3.name) {
              case "NotSupportedError":
                t2.length > 0 && (n3.adoptedStyleSheets = t2);
                break;
              default:
                throw r3;
            }
          }({ error: e3, styleSheets: f2, root: j2 });
        }
    }, [c3, v2, f2]), e.createElement(e.Fragment, null, e.createElement(n2.tag, p({ key: z, ref: v2 }, h2), (j2 || d2) && e.createElement(w.Provider, { value: j2 }, d2 ? e.createElement("template", { shadowroot: "open" }, n2.render({ root: j2, ssr: d2, children: y2 })) : e.createElement(O, { root: j2 }, n2.render({ root: j2, ssr: d2, children: y2 })))));
  });
  return c2.propTypes = { mode: i.oneOf(["open", "closed"]), delegatesFocus: i.bool, styleSheets: i.arrayOf(i.instanceOf(globalThis.CSSStyleSheet)), ssr: i.bool, children: i.node }, c2.defaultProps = { mode: "open", delegatesFocus: false, styleSheets: [], ssr: false, children: null }, c2;
}
O.propTypes = { root: i.object.isRequired, children: i.node }, O.defaultProps = { children: null };
var x = /* @__PURE__ */ new Map();
function E() {
  var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "core", t2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function(e3) {
    return e3.children;
  };
  return new Proxy(e2, { get: function(e3, n2) {
    var o2 = f(n2, { separator: "-" }), a2 = "".concat(r2, "-").concat(o2);
    return x.has(a2) || x.set(a2, j({ tag: o2, render: t2 })), x.get(a2);
  } });
}
var A = E();
var react_shadow_esm_default = A;

// src/components/ArtboardContainer.tsx
import { useComponents } from "@ballpark/design-renderer-base";
import { jsx as jsx9 } from "react/jsx-runtime";
var ArtboardContainer = (props) => {
  const { Artboard: Artboard3 } = useComponents();
  return /* @__PURE__ */ jsx9(Artboard3, __spreadValues({}, props));
};

// src/components/Fonts.tsx
import { useFonts } from "@ballpark/design-plugin-fonts";
import { useComponents as useComponents2 } from "@ballpark/design-renderer-base";
import { observer as observer10 } from "mobx-react";
import { jsx as jsx10 } from "react/jsx-runtime";
var Fonts = observer10(function Fonts2() {
  const elements = useComponents2();
  const { fontFaces } = useFonts();
  return /* @__PURE__ */ jsx10(elements.Head, { children: /* @__PURE__ */ jsx10("style", { type: "text/css", children: fontFaces.map(
    ({ fontFamily, fontStyle, fontWeight, src }) => `
            @font-face {
              font-family: "${fontFamily}";
              font-style: ${fontStyle};
              font-weight: ${fontWeight};
              src: ${src.map(({ url, format }) => `url("${url}") format("${format}")`).join(", ")};
            }
            `
  ).join("") }) });
});

// src/components/context/DefaultComponentsProvider.tsx
import { ComponentsProvider } from "@ballpark/design-renderer-base";
import React11 from "react";

// src/components/Connector.tsx
import {
  ConnectorUtils,
  ItemUtils as ItemUtils3,
  LineDecoration as LineDecoration3,
  NumberUtils as NumberUtils2,
  PointUtils as PointUtils3,
  StrokeUtils as StrokeUtils2,
  TextUtils as TextUtils2
} from "@ballpark/design-creator";
import {
  arcCorners,
  computeLabelPosition,
  normalizePoints,
  offsetPoints,
  route
} from "@ballpark/design-plugin-connection";
import { useDesign as useDesign4 } from "@ballpark/design-plugin-react";
import { autoSizableText } from "@ballpark/design-plugin-text";
import { useView as useView2 } from "@ballpark/design-plugin-view";
import { observer as observer12 } from "mobx-react";
import React6 from "react";

// src/components/Text.tsx
import {
  FontStyle,
  ItemUtils as ItemUtils2,
  SizeUtils,
  TextUtils
} from "@ballpark/design-creator";
import { useFontLoaded, useFonts as useFonts2 } from "@ballpark/design-plugin-fonts";
import { observer as observer11 } from "mobx-react";
import React5, { useRef } from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var TextWrapper = observer11(function TextWrapper2(_a) {
  var _b = _a, {
    data,
    globalMatrixCache,
    children,
    textRef
  } = _b, props = __objRest(_b, [
    "data",
    "globalMatrixCache",
    "children",
    "textRef"
  ]);
  var _a2;
  const { id, style, size, sizing } = data;
  const prevTextStyle = useRef(null);
  const { italic } = style;
  const fontStyle = italic ? FontStyle.Italic : FontStyle.Normal;
  const fontLoaded = useFontLoaded(__spreadValues({ fontStyle }, style));
  const [width, height] = size;
  const [sizingX, sizingY] = sizing;
  const isAbsoluteX = sizingX === "absolute";
  const isAbsoluteY = sizingY === "absolute";
  const fonts = useFonts2();
  if (isAbsoluteX && !width || isAbsoluteY && !height)
    return null;
  if (!fontLoaded && !prevTextStyle.current)
    return null;
  const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
  const actualWidth = Math.ceil(width * globalMatrixScalingX);
  const actualHeight = Math.ceil(height * globalMatrixScalingY);
  const actualSize = SizeUtils.create(actualWidth, actualHeight);
  const textStyle = !fontLoaded && prevTextStyle.current ? prevTextStyle.current : TextUtils.computeTextStylesCss(data, actualSize, fonts.fontFaces);
  if (fontLoaded) {
    prevTextStyle.current = textStyle;
  }
  const overflow = (_a2 = ItemUtils2.getClientData(data).overflow) != null ? _a2 : true;
  return (
    // this has to be on a group not the foreignObject due to a bug in Safari
    // https://bugs.webkit.org/show_bug.cgi?id=23113
    /* @__PURE__ */ jsx11(
      "g",
      {
        transform: `scale(${1 / globalMatrixScalingX}, ${1 / globalMatrixScalingY})`,
        children: /* @__PURE__ */ jsx11(
          "foreignObject",
          {
            height: actualHeight || 1,
            style: {
              overflow: overflow ? "visible" : "hidden"
            },
            width: actualWidth || 1,
            children: /* @__PURE__ */ jsx11("div", __spreadProps(__spreadValues({ id, ref: textRef }, props), { style: textStyle, children }))
          }
        )
      }
    )
  );
});
var Text = observer11(
  React5.forwardRef(
    function Text2(props, ref) {
      const { blocks, id } = props.data;
      return /* @__PURE__ */ jsx11(TextWrapper, __spreadProps(__spreadValues({}, props), { textRef: ref, children: blocks.map(({ text }, i2) => /* @__PURE__ */ jsx11(
        Block,
        {
          id: i2 === blocks.length - 1 ? `${id}-end` : void 0,
          children: text
        },
        i2
      )) }));
    }
  )
);
function Block({ children, id }) {
  return /* @__PURE__ */ jsx11("div", { children: /* @__PURE__ */ jsx11("span", { id, children: children || /* @__PURE__ */ jsx11("br", {}) }) });
}

// src/components/Connector.tsx
import { Fragment as Fragment2, jsx as jsx12, jsxs as jsxs3 } from "react/jsx-runtime";
var Connector = observer12(function Connector2({
  data,
  globalMatrixCache,
  hideDecorations
}) {
  const design = useDesign4();
  const startPoint = design.getStartPoint(data.id, true);
  const endPoint = design.getEndPoint(data.id, true);
  const emptyGlobalMatrixCache = useGlobalMatrixCache(null);
  if (!startPoint || !endPoint)
    return null;
  return /* @__PURE__ */ jsx12(React6.Fragment, { children: /* @__PURE__ */ jsx12(Untransform, { globalMatrixCache, children: /* @__PURE__ */ jsx12(
    ConnectorPath,
    {
      data,
      startX: startPoint[0],
      startY: startPoint[1],
      endX: endPoint[0],
      endY: endPoint[1],
      globalMatrixCache: emptyGlobalMatrixCache,
      hideDecorations
    }
  ) }) });
});
var ConnectorPath = observer12(function ConnectorPolyline({
  startX,
  startY,
  endX,
  endY,
  data,
  globalMatrixCache,
  hideDecorations
}) {
  const stroke = ItemUtils3.getStrokes(data)[0];
  const strokeWidth = stroke ? StrokeUtils2.getWidth(stroke) : 0;
  const startDecorationType = data.startDecoration;
  const endDecorationType = data.endDecoration;
  const startOffset = getDecorationOffset(startDecorationType, strokeWidth);
  const endOffset = getDecorationOffset(endDecorationType, strokeWidth);
  const { points } = useConnectorPoints(
    data,
    [startX, startY],
    [endX, endY],
    startOffset,
    endOffset
  );
  return /* @__PURE__ */ jsx12(
    ConnectorPathInner,
    {
      data,
      globalMatrixCache,
      points,
      hideDecorations,
      startDecorationType,
      endDecorationType,
      strokeWidth
    }
  );
});
var ConnectorPathInner = observer12(function ConnectorPathInner2({
  data,
  points,
  strokeWidth,
  startDecorationType,
  endDecorationType,
  globalMatrixCache,
  hideDecorations
}) {
  var _a;
  const view = useView2();
  const ignoreZoom = ConnectorUtils.isIgnoreZoom(data);
  const radius = (_a = data.radius) != null ? _a : 16;
  const zoomScale = ignoreZoom ? Math.max(ConnectorUtils.getMinIgnoreZoom(data), view.zoomFactor) : 1;
  const segments = arcCorners(points, radius / zoomScale);
  const { d: d2, startDecoration, endDecoration } = segmentsToDecoratedSVGPath(
    segments,
    {
      strokeWidth,
      startDecorationType,
      endDecorationType,
      // specifically define the angles based on the right angled segments instead of relying on the
      // standard angle calculation for any path which handles curves etc
      startDecorationAngle: points.length > 1 ? PointUtils3.getAngleBetweenRight(points[1], points[0]) : void 0,
      endDecorationAngle: points.length > 1 ? PointUtils3.getAngleBetweenRight(
        points[points.length - 2],
        points[points.length - 1]
      ) : void 0
    }
  );
  return /* @__PURE__ */ jsxs3(Fragment2, { children: [
    /* @__PURE__ */ jsx12(
      DPath,
      {
        data,
        d: d2,
        startDecoration,
        endDecoration,
        globalMatrixCache,
        hideDecorations,
        ignoreZoom,
        minIgnoreZoom: ConnectorUtils.getMinIgnoreZoom(data)
      }
    ),
    /* @__PURE__ */ jsx12(
      ConnectorLabel,
      {
        points,
        data,
        globalMatrixCache
      }
    )
  ] });
});
function getLabelBuffer(size, align) {
  if (align === "start") {
    return [size[0] / 2, size[1] / 2];
  }
  if (align === "end") {
    return [-size[0] / 2, -size[1] / 2];
  }
  return [0, 0];
}
var ConnectorText = autoSizableText(Text, true);
var ConnectorLabel = observer12(function ConnectorLabel2({
  points,
  data,
  globalMatrixCache
}) {
  var _a;
  const view = useView2();
  const { text } = data;
  if (!text)
    return null;
  if (TextUtils2.isEmpty(text))
    return null;
  const stroke = ItemUtils3.getStrokes(data)[0];
  if (!stroke)
    return null;
  const labelPositionData = ConnectorUtils.getLabelPosition(data, points);
  const { align } = labelPositionData;
  const ignoreZoom = ConnectorUtils.isIgnoreZoom(data);
  const zoomScale = ignoreZoom ? Math.max(ConnectorUtils.getMinIgnoreZoom(data), view.zoomFactor) : 1;
  const counterScale = 1 / zoomScale;
  const { size } = text;
  const padding = (_a = data.labelPadding) != null ? _a : [
    text.style.fontSize * 1.5,
    text.style.fontSize * 0.5
  ];
  const sizeWithPadding = PointUtils3.add(size, padding);
  const labelPosition = computeLabelPosition(
    points,
    labelPositionData,
    counterScale,
    getLabelBuffer(PointUtils3.divide(sizeWithPadding, zoomScale), align)
  );
  if (!labelPosition)
    return null;
  const { point, segment } = labelPosition;
  const [r2, g2, b2, a2] = stroke.color.rgbaValues;
  const fill = `rgba(${r2 * 255}, ${g2 * 255}, ${b2 * 255}, ${a2 * 255})`;
  const radius = Math.min(sizeWithPadding[0], sizeWithPadding[1]) / 2;
  const { x: x2, y: y2 } = getLabelAdjustment(
    sizeWithPadding,
    segment,
    // if the label overflowed, center align it so doesn't jump
    labelPosition.overflowed ? "center" : align,
    counterScale
  );
  return /* @__PURE__ */ jsxs3(
    "g",
    {
      transform: `translate(${x2 + point[0] - sizeWithPadding[0] * counterScale / 2} ${y2 + point[1] - sizeWithPadding[1] * counterScale / 2}) scale(${counterScale})`,
      children: [
        /* @__PURE__ */ jsx12(
          "rect",
          {
            width: sizeWithPadding[0],
            height: sizeWithPadding[1],
            fill,
            rx: radius,
            ry: radius
          }
        ),
        /* @__PURE__ */ jsx12("g", { transform: `translate(${padding[0] / 2}, ${padding[1] / 2})`, children: /* @__PURE__ */ jsx12(ConnectorText, { data: text, globalMatrixCache }) })
      ]
    }
  );
});
function getLabelAdjustment(labelSize, segment, labelAlignment = "center", scale = 1) {
  if (labelAlignment === "center") {
    return { x: 0, y: 0 };
  }
  const isHorizontal = NumberUtils2.isCloseTo(segment[0][1], segment[1][1]);
  const labelDirection = labelAlignment === "start" ? 1 : -1;
  if (isHorizontal) {
    const forwards2 = segment[0][0] < segment[1][0];
    const segmentDirection2 = forwards2 ? 1 : -1;
    const direction2 = segmentDirection2 * labelDirection;
    return { x: labelSize[0] / 2 * direction2 * scale, y: 0 };
  }
  const forwards = segment[0][1] < segment[1][1];
  const segmentDirection = forwards ? 1 : -1;
  const direction = segmentDirection * labelDirection;
  return { x: 0, y: labelSize[1] / 2 * direction * scale };
}
function getDecorationOffset(decoration, strokeWidth) {
  switch (decoration) {
    case LineDecoration3.Circle:
      return 0;
    case LineDecoration3.None:
    default:
      return strokeWidth / 2 + 5;
  }
}
function useConnectorPoints(connector, start, end, startOffset = 0, endOffset = 0) {
  var _a;
  const design = useDesign4();
  const points = [];
  const graphs = [];
  const pointsOfInterest = [start, ...(_a = connector.points) != null ? _a : [], end];
  pointsOfInterest.forEach((pointOfInterest, index) => {
    if (index === 0)
      return;
    const prevPointOfInterest = pointsOfInterest[index - 1];
    const entryAngle = points.length > 2 ? PointUtils3.getAngleBetweenRight(
      points[points.length - 2],
      points[points.length - 1]
    ) : void 0;
    const { points: newPoints, graph } = route(
      design,
      connector,
      prevPointOfInterest,
      pointOfInterest,
      index === 1,
      index === pointsOfInterest.length - 1,
      entryAngle,
      // prevent zig-zagging on any route with additional points of interest
      pointsOfInterest.length > 2
    );
    points.push(...newPoints);
    if (graph)
      graphs.push(graph);
  });
  return {
    points: normalizePoints(offsetPoints(points, startOffset, endOffset)),
    graphs
  };
}
var DebugConnectorGraph = observer12(function DebugConnectorGraph2({
  graph
}) {
  if (!graph)
    return null;
  const lines = [];
  const dots = [];
  graph.forEachLink((link) => {
    const from = graph.getNode(link.fromId);
    const to = graph.getNode(link.toId);
    if (from && to) {
      lines.push({
        data: [
          [from.data.point[0], from.data.point[1]],
          [to.data.point[0], to.data.point[1]]
        ],
        id: link.id,
        isMid: from.data.isMid && to.data.isMid
      });
    }
  });
  graph.forEachNode((node) => {
    dots.push({
      data: [node.data.point[0], node.data.point[1]],
      isMid: node.data.isMid,
      id: node.id
    });
  });
  return /* @__PURE__ */ jsxs3(Fragment2, { children: [
    lines.map(({ data: [start, end], id, isMid }) => {
      return /* @__PURE__ */ jsx12(
        "line",
        {
          x1: start[0],
          y1: start[1],
          x2: end[0],
          y2: end[1],
          opacity: 0.3,
          stroke: isMid ? "purple" : "#FF8F8F"
        },
        id
      );
    }),
    dots.map(({ data: [start, end], id, isMid }) => {
      return /* @__PURE__ */ jsx12(
        "circle",
        {
          cx: start,
          cy: end,
          r: 5,
          fill: isMid ? "purple" : "#FF8F8F"
        },
        id
      );
    })
  ] });
});
var DebugConnectorPointsOfInterest = observer12(
  function DebugConnectorPointsOfInterest2({
    connector
  }) {
    var _a;
    const design = useDesign4();
    const start = design.getStartPoint(connector.id, true);
    const end = design.getEndPoint(connector.id, true);
    if (!start || !end)
      return null;
    const pointsOfInterest = [start, ...(_a = connector.points) != null ? _a : [], end];
    return /* @__PURE__ */ jsx12(Fragment2, { children: pointsOfInterest.map((point, index) => {
      const [x2, y2] = point;
      const prevPoint = pointsOfInterest[index - 1];
      if (!prevPoint) {
        return /* @__PURE__ */ jsx12(
          "circle",
          {
            cx: x2,
            cy: y2,
            r: 5,
            fill: "green"
          },
          `point-${index}`
        );
      }
      const [prevX, prevY] = prevPoint;
      return /* @__PURE__ */ jsxs3(Fragment2, { children: [
        /* @__PURE__ */ jsx12(
          "circle",
          {
            cx: x2,
            cy: y2,
            r: 5,
            fill: "green"
          },
          `point-${index}`
        ),
        /* @__PURE__ */ jsx12(
          "line",
          {
            x1: prevX,
            y1: prevY,
            x2,
            y2,
            stroke: "green"
          },
          `line-${index}`
        )
      ] });
    }) });
  }
);

// src/components/Ellipse.tsx
import { observer as observer14 } from "mobx-react";
import React7 from "react";

// src/components/draw/SvgEllipse.tsx
import { observer as observer13 } from "mobx-react";
import PropTypes3 from "prop-types";
import { jsx as jsx13 } from "react/jsx-runtime";
function SvgEllipse({
  cx,
  cy,
  fill,
  filter,
  fillRule,
  globalMatrixCache,
  mixBlendMode,
  rx,
  ry,
  stroke,
  strokeDasharray,
  strokeLinecap,
  strokeLinejoin,
  strokeMiterlimit,
  strokePosition,
  strokeWidth
}) {
  let strokeAdjustedRx = rx;
  let strokeAdjustedRy = ry;
  if (strokePosition === "inside") {
    const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
    const adjustedStrokeWidth = strokeWidth / 2;
    strokeAdjustedRx = Math.max(
      rx - adjustedStrokeWidth / globalMatrixScalingX,
      rx / 4
    );
    strokeAdjustedRy = Math.max(
      ry - adjustedStrokeWidth / globalMatrixScalingY,
      ry / 4
    );
  } else if (strokePosition === "outside") {
    const [globalMatrixScalingX, globalMatrixScalingY] = globalMatrixCache.scaling;
    const adjustedStrokeWidth = strokeWidth / 2;
    strokeAdjustedRx = Math.max(
      rx + adjustedStrokeWidth / globalMatrixScalingX,
      rx / 4
    );
    strokeAdjustedRy = Math.max(
      ry + adjustedStrokeWidth / globalMatrixScalingY,
      ry / 4
    );
  }
  return /* @__PURE__ */ jsx13(
    "ellipse",
    {
      cx,
      cy,
      fill,
      fillRule,
      filter,
      rx: strokeAdjustedRx,
      ry: strokeAdjustedRy,
      stroke,
      strokeDasharray,
      strokeLinecap,
      strokeLinejoin,
      strokeMiterlimit,
      strokeWidth,
      style: {
        mixBlendMode
      },
      vectorEffect: "non-scaling-stroke"
    }
  );
}
SvgEllipse.propTypes = {
  cx: PropTypes3.number,
  cy: PropTypes3.number,
  rx: PropTypes3.number,
  ry: PropTypes3.number,
  fill: PropTypes3.string,
  fillRule: PropTypes3.string,
  mixBlendMode: blendMode_default,
  stroke: PropTypes3.string,
  strokeDasharray: PropTypes3.string,
  strokeLinecap: PropTypes3.string,
  strokeLinejoin: PropTypes3.string,
  strokeMiterlimit: PropTypes3.number,
  strokeWidth: PropTypes3.number
};
SvgEllipse.defaultProps = {
  cx: 0,
  cy: 0,
  rx: 0,
  ry: 0,
  fill: "none",
  filter: void 0,
  fillRule: void 0,
  mixBlendMode: "normal",
  stroke: "none",
  strokeDasharray: void 0,
  strokeLinecap: void 0,
  strokeLinejoin: void 0,
  strokeMiterlimit: void 0,
  strokeWidth: 0
};
var SvgEllipse_default = observer13(SvgEllipse);

// src/components/Ellipse.tsx
import { jsx as jsx14, jsxs as jsxs4 } from "react/jsx-runtime";
var Ellipse = observer14(function Ellipse2({
  clipPathId,
  data,
  globalMatrixCache
}) {
  const { id, size } = data;
  const [width, height] = size;
  const shapeProps = {
    cx: width / 2,
    cy: height / 2,
    rx: width / 2,
    ry: height / 2
  };
  return /* @__PURE__ */ jsxs4(React7.Fragment, { children: [
    clipPathId && /* @__PURE__ */ jsx14("clipPath", { id: clipPathId, children: /* @__PURE__ */ jsx14(SvgEllipse_default, __spreadValues({}, shapeProps)) }),
    /* @__PURE__ */ jsx14(
      Fills_default,
      __spreadValues({
        Component: SvgEllipse_default,
        fillStyle: data.fillStyle,
        id
      }, shapeProps)
    ),
    /* @__PURE__ */ jsx14(
      Strokes,
      __spreadValues({
        Component: SvgEllipse_default,
        data,
        globalMatrixCache
      }, shapeProps)
    )
  ] });
});

// src/components/Group.tsx
import { useComponents as useComponents3 } from "@ballpark/design-renderer-base";
import { observer as observer15 } from "mobx-react";
import { jsx as jsx15 } from "react/jsx-runtime";
var Group = observer15(function Group2(_a) {
  var _b = _a, {
    data
  } = _b, otherProps = __objRest(_b, [
    "data"
  ]);
  const { NodeList: NodeList3 } = useComponents3();
  return /* @__PURE__ */ jsx15(NodeList3, __spreadValues({ nodes: data.children }, otherProps));
});

// src/components/Head.tsx
import { Helmet as BaseHelmet, HelmetData } from "react-helmet-async";
import { jsx as jsx16 } from "react/jsx-runtime";
var helmetData = new HelmetData({});
var Head = (props) => {
  return /* @__PURE__ */ jsx16(BaseHelmet, __spreadProps(__spreadValues({}, props), { helmetData }));
};

// src/components/Interaction.tsx
import { observer as observer16 } from "mobx-react";
import React8 from "react";
import { Fragment as Fragment3, jsx as jsx17, jsxs as jsxs5 } from "react/jsx-runtime";
var Interaction = observer16(
  React8.forwardRef(
    function Interaction2(_a, ref) {
      var _b = _a, { children, bounds } = _b, props = __objRest(_b, ["children", "bounds"]);
      if (!bounds)
        return /* @__PURE__ */ jsx17("g", __spreadProps(__spreadValues({}, props), { ref, children }));
      const {
        size: [width, height],
        point: [x2, y2]
      } = bounds;
      return /* @__PURE__ */ jsxs5(Fragment3, { children: [
        children,
        /* @__PURE__ */ jsx17(
          "rect",
          __spreadProps(__spreadValues({}, props), {
            ref,
            style: { pointerEvents: "all" },
            x: x2,
            y: y2,
            width,
            height,
            fill: "none"
          })
        )
      ] });
    }
  )
);

// src/components/Mask.tsx
import { useDesign as useDesign6 } from "@ballpark/design-plugin-react";
import { useComponents as useComponents5 } from "@ballpark/design-renderer-base";
import { observer as observer18 } from "mobx-react";

// src/components/NodeContainer.tsx
import { useDesign as useDesign5 } from "@ballpark/design-plugin-react";
import { useComponents as useComponents4 } from "@ballpark/design-renderer-base";
import { observer as observer17 } from "mobx-react";
import { jsx as jsx18 } from "react/jsx-runtime";
var NodeContainer = observer17(function NodeContainer2(props) {
  const { getItemById } = useDesign5();
  const _a = props, { data: dataOrId } = _a, otherProps = __objRest(_a, ["data"]);
  const elements = useComponents4();
  const globalMatrixCache = useGlobalMatrixCache(
    typeof dataOrId === "string" ? dataOrId : dataOrId.id
  );
  const data = typeof dataOrId === "string" ? getItemById(dataOrId) : dataOrId;
  if (!data)
    return null;
  return /* @__PURE__ */ jsx18(
    elements.Node,
    __spreadProps(__spreadValues({}, otherProps), {
      data,
      globalMatrixCache
    })
  );
});

// src/components/Mask.tsx
import { Fragment as Fragment4, jsx as jsx19, jsxs as jsxs6 } from "react/jsx-runtime";
var Mask = observer18(function Mask2(_a) {
  var _b = _a, { data } = _b, otherProps = __objRest(_b, ["data"]);
  const { NodeList: NodeList3 } = useComponents5();
  const { getItemById } = useDesign6();
  const clipNode = getItemById(data.children[0]);
  if (!clipNode)
    return null;
  const clipPathId = `clipPath-${data.id}`;
  return /* @__PURE__ */ jsxs6(Fragment4, { children: [
    /* @__PURE__ */ jsx19(
      NodeContainer,
      __spreadValues({
        clipPathId,
        data: clipNode
      }, otherProps),
      clipNode.id
    ),
    /* @__PURE__ */ jsx19("g", { clipPath: `url(#${clipPathId})`, children: /* @__PURE__ */ jsx19(NodeList3, __spreadValues({ nodes: data.children }, otherProps)) })
  ] });
});

// src/components/Node.tsx
import { MatrixUtils as MatrixUtils5 } from "@ballpark/design-creator";
import { useComponents as useComponents6 } from "@ballpark/design-renderer-base";
import { observer as observer21 } from "mobx-react";

// src/components/draw/BlurFilter.tsx
import { observer as observer19 } from "mobx-react";
import { jsx as jsx20 } from "react/jsx-runtime";
function hasBlur(data) {
  return data.itemProps.blur > 0;
}
var BlurFilter = observer19(function BlurFilter2({ data, id: blurId }) {
  if (!hasBlur(data))
    return null;
  return /* @__PURE__ */ jsx20("filter", { height: "200%", id: blurId, width: "200%", x: "-50%", y: "-50%", children: /* @__PURE__ */ jsx20("feGaussianBlur", { in: "SourceGraphic", stdDeviation: data.blur }) });
});

// src/components/draw/ShadowFilter.tsx
import { ColorUtils } from "@ballpark/design-creator";
import { observer as observer20 } from "mobx-react";
import { Fragment as Fragment5, jsx as jsx21, jsxs as jsxs7 } from "react/jsx-runtime";
function hasShadow(data) {
  return data.shadows && data.shadows.filter(isVisible).length > 0;
}
var ShadowFilter = observer20(function ShadowFilter2({
  data,
  id: shadowId
}) {
  if (!hasShadow(data))
    return null;
  const shadowDefs = data.shadows.map((shadow, i2) => {
    if (!isVisible(shadow))
      return null;
    const [dx, dy] = shadow.offset;
    const [r2, g2, b2, a2] = ColorUtils.getRgba(shadow.color);
    const inside = i2 === 0 ? "BackgroundImageFix" : `dropShadow${i2 - 1}`;
    const out = `dropShadow${i2}`;
    return /* @__PURE__ */ jsxs7(Fragment5, { children: [
      /* @__PURE__ */ jsx21(
        "feColorMatrix",
        {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }
      ),
      /* @__PURE__ */ jsx21("feOffset", { dx, dy }),
      /* @__PURE__ */ jsx21("feGaussianBlur", { stdDeviation: shadow.blur / 2 }),
      /* @__PURE__ */ jsx21(
        "feColorMatrix",
        {
          type: "matrix",
          values: `0 0 0 0 ${r2} 0 0 0 0 ${g2} 0 0 0 0 ${b2} 0 0 0 ${a2} 0`
        }
      ),
      /* @__PURE__ */ jsx21("feBlend", { in2: inside, mode: "normal", result: out })
    ] });
  });
  return /* @__PURE__ */ jsxs7(
    "filter",
    {
      colorInterpolationFilters: "sRGB",
      filterUnits: "objectBoundingBox",
      height: "200%",
      id: shadowId,
      width: "200%",
      x: "-50%",
      y: "-50%",
      children: [
        /* @__PURE__ */ jsx21("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        shadowDefs,
        /* @__PURE__ */ jsx21(
          "feBlend",
          {
            in: "SourceGraphic",
            in2: `dropShadow${shadowDefs.length - 1}`,
            mode: "normal",
            result: "shape"
          }
        )
      ]
    }
  );
});
function isVisible(shadow) {
  if (!shadow.enabled)
    return false;
  const [x2, y2] = shadow.offset;
  if (shadow.blur === 0 && x2 === 0 && y2 === 0 && shadow.shadowSpread === 0)
    return false;
  return true;
}

// src/components/Node.tsx
import { Fragment as Fragment6, jsx as jsx22, jsxs as jsxs8 } from "react/jsx-runtime";
var Node = observer21(function Node2(props) {
  const { data, noPointerEvents, globalMatrixCache } = props;
  const { className, itemProps } = data;
  const { opacity, matrix } = itemProps;
  const elements = useComponents6();
  const Element = elements[className];
  if (!Element)
    return null;
  return /* @__PURE__ */ jsx22(WithFilters, { data, globalMatrixCache, children: /* @__PURE__ */ jsx22(
    "g",
    {
      opacity,
      style: {
        mixBlendMode: itemProps.blendMode,
        pointerEvents: noPointerEvents ? "none" : "visiblePainted"
      },
      transform: `matrix(${matrix.join(" ")})`,
      children: /* @__PURE__ */ jsx22(Element, __spreadValues({}, props))
    }
  ) });
});
function WithFilters({ children, data, globalMatrixCache }) {
  const { id } = data;
  const blurId = hasBlur(data) ? `${id}-blur` : null;
  const shadowId = hasShadow(data) ? `${id}-shadow` : null;
  const filterUrl = [shadowId, blurId].map((filterId) => filterId ? `url(#${filterId})` : "").join(" ").trim();
  if (!filterUrl)
    return children;
  const globalMatrix = globalMatrixCache.matrix;
  const inverseGlobalMatrix = MatrixUtils5.invert(globalMatrixCache.matrix);
  return /* @__PURE__ */ jsxs8(Fragment6, { children: [
    filterUrl && /* @__PURE__ */ jsxs8("defs", { children: [
      /* @__PURE__ */ jsx22(BlurFilter, { data, id: blurId }),
      /* @__PURE__ */ jsx22(ShadowFilter, { data, id: shadowId })
    ] }),
    /* @__PURE__ */ jsx22(
      "g",
      {
        filter: !filterUrl ? void 0 : filterUrl,
        transform: `matrix(${inverseGlobalMatrix.join(" ")})`,
        children: /* @__PURE__ */ jsx22("g", { transform: `matrix(${globalMatrix.join(" ")})`, children })
      }
    )
  ] });
}

// src/components/NodeList.tsx
import { observer as observer22 } from "mobx-react";
import { Fragment as Fragment7, jsx as jsx23 } from "react/jsx-runtime";
import { createElement as createElement3 } from "react";
var NodeList = observer22(
  function NodeList2(_a) {
    var _b = _a, { nodes } = _b, otherProps = __objRest(_b, ["nodes"]);
    return /* @__PURE__ */ jsx23(Fragment7, { children: nodes.map((nodeOrId) => /* @__PURE__ */ createElement3(
      NodeContainer,
      __spreadProps(__spreadValues({}, otherProps), {
        data: nodeOrId,
        key: typeof nodeOrId === "string" ? nodeOrId : nodeOrId.id
      })
    )) });
  }
);

// src/components/Raster.tsx
import { ItemUtils as ItemUtils4, PointUtils as PointUtils5, RasterUtils } from "@ballpark/design-creator";
import { useWeakImage as useWeakImage2 } from "@ballpark/design-plugin-image";
import { observer as observer25 } from "mobx-react";
import React9 from "react";

// src/components/SVG.tsx
import { FillUtils as FillUtils2 } from "@ballpark/design-creator";
import { observer as observer23 } from "mobx-react";
import { Fragment as Fragment8, jsx as jsx24, jsxs as jsxs9 } from "react/jsx-runtime";
var SVG = observer23(function SVG2({ data, url }) {
  const { id, size } = data;
  const [width, height] = size;
  const fill = data.fillStyle.fills[0];
  const isColorFill = fill && FillUtils2.isColorFill(fill);
  return /* @__PURE__ */ jsxs9(Fragment8, { children: [
    url && /* @__PURE__ */ jsx24("g", { display: isColorFill ? "none" : "block", children: /* @__PURE__ */ jsx24(
      "image",
      {
        height,
        href: url,
        id,
        preserveAspectRatio: "none",
        width
      }
    ) }),
    isColorFill && renderIconFill(id, fill)
  ] });
});
function renderIconFill(id, fill) {
  const [r2, g2, b2, a2] = fill.content.rgbaValues;
  const matrix = `
    0 0 0 0 ${r2}
    0 0 0 0 ${g2}
    0 0 0 0 ${b2}
    0 0 0 ${a2} 0`;
  return /* @__PURE__ */ jsxs9(Fragment8, { children: [
    /* @__PURE__ */ jsx24("filter", { id: `${id}-fill`, children: /* @__PURE__ */ jsx24("feColorMatrix", { in: "SourceGraphic", type: "matrix", values: matrix }) }),
    /* @__PURE__ */ jsx24("use", { filter: `url(#${id}-fill)`, href: `#${id}` })
  ] });
}

// src/components/draw/RoundedRect.tsx
import { PointUtils as PointUtils4 } from "@ballpark/design-creator";
import { observer as observer24 } from "mobx-react";
import { jsx as jsx25 } from "react/jsx-runtime";
var RoundedRect = observer24(function RoundedRect2(_a) {
  var _b = _a, { radius } = _b, props = __objRest(_b, ["radius"]);
  const { globalMatrixCache, width, height } = props;
  const rectHasDifferingRadii = !radius.every((radii) => radii === radius[0]);
  const shapeProps = props;
  const strokeAdjustedRectangle = useStrokeAdjustedRectangle();
  const inverseGlobalScaling = PointUtils4.reciprocal(globalMatrixCache.scaling);
  if (rectHasDifferingRadii) {
    const { x: x2, y: y2, strokePosition, strokeWidth } = props;
    const {
      x: adjustedX,
      y: adjustedY,
      width: adjustedWidth,
      height: adjustedHeight,
      radius: adjustedRadius
    } = strokeAdjustedRectangle({
      x: x2,
      y: y2,
      width,
      height,
      globalMatrixCache,
      radius,
      strokePosition,
      strokeWidth
    });
    shapeProps.d = createPathString({
      w: adjustedWidth,
      h: adjustedHeight,
      x: adjustedX,
      y: adjustedY,
      radius: adjustedRadius,
      scale: inverseGlobalScaling
    });
  } else {
    shapeProps.rx = radius[0] * inverseGlobalScaling[0];
    shapeProps.ry = radius[0] * inverseGlobalScaling[1];
  }
  const SvgComponent = rectHasDifferingRadii ? SvgPath_default : SvgRect_default;
  return /* @__PURE__ */ jsx25(SvgComponent, __spreadValues({}, shapeProps));
});

// src/components/Raster.tsx
import { jsx as jsx26, jsxs as jsxs10 } from "react/jsx-runtime";
var Raster = observer25(function Raster2({
  data,
  globalMatrixCache
}) {
  const image = useWeakImage2();
  const { id, radius, size } = data;
  const [width, height] = size;
  const url = image.getActualUrl(data.source);
  if (RasterUtils.getFormat(data) === "svg") {
    return /* @__PURE__ */ jsx26(SVG, { data, url });
  }
  const cappedRadius = capRadius(
    radius,
    PointUtils5.multiply(size, globalMatrixCache.scaling)
  );
  const shapeProps = {
    width,
    height,
    x: 0,
    y: 0,
    radius: cappedRadius,
    globalMatrixCache
  };
  return /* @__PURE__ */ jsxs10(React9.Fragment, { children: [
    /* @__PURE__ */ jsx26("clipPath", { id: `clip-path-id-${id}`, children: /* @__PURE__ */ jsx26(RoundedRect, __spreadValues({}, shapeProps)) }),
    url && /* @__PURE__ */ jsx26(
      "image",
      {
        clipPath: `url(#clip-path-id-${id})`,
        height,
        href: url,
        opacity: ItemUtils4.getOpacity(data),
        preserveAspectRatio: "none",
        width
      }
    ),
    /* @__PURE__ */ jsx26(
      Fills_default,
      __spreadValues({
        Component: RoundedRect,
        fillStyle: data.fillStyle,
        id
      }, shapeProps)
    ),
    /* @__PURE__ */ jsx26(Strokes, __spreadValues({ Component: RoundedRect, data }, shapeProps))
  ] });
});

// src/components/Rectangle.tsx
import { PointUtils as PointUtils6 } from "@ballpark/design-creator";
import { observer as observer26 } from "mobx-react";
import React10 from "react";
import { jsx as jsx27, jsxs as jsxs11 } from "react/jsx-runtime";
var Rectangle = observer26(function Rectangle2({
  clipPathId,
  data,
  globalMatrixCache
}) {
  const { id, radius, size } = data;
  const [width, height] = size;
  const cappedRadius = capRadius(
    radius,
    PointUtils6.multiply(size, globalMatrixCache.scaling)
  );
  const shapeProps = {
    width,
    height,
    x: 0,
    y: 0,
    radius: cappedRadius
  };
  return /* @__PURE__ */ jsxs11(React10.Fragment, { children: [
    clipPathId && /* @__PURE__ */ jsx27("clipPath", { id: clipPathId, children: /* @__PURE__ */ jsx27(RoundedRect, __spreadValues({}, shapeProps)) }),
    /* @__PURE__ */ jsx27(
      Fills_default,
      __spreadValues({
        Component: RoundedRect,
        fillStyle: data.fillStyle,
        globalMatrixCache,
        id
      }, shapeProps)
    ),
    /* @__PURE__ */ jsx27(
      Strokes,
      __spreadValues({
        Component: RoundedRect,
        data,
        globalMatrixCache
      }, shapeProps)
    )
  ] });
});

// src/components/Shape.tsx
import { ShapeType } from "@ballpark/design-creator";
import { useComponents as useComponents7 } from "@ballpark/design-renderer-base";
import { observer as observer27 } from "mobx-react";
import { jsx as jsx28 } from "react/jsx-runtime";
var Shape = observer27(function Shape2(props) {
  const { Rectangle: Rectangle3, Ellipse: Ellipse3 } = useComponents7();
  switch (props.data.type) {
    case ShapeType.Rectangle:
      return /* @__PURE__ */ jsx28(
        Rectangle3,
        __spreadProps(__spreadValues({}, props), {
          data: props.data
        })
      );
    case ShapeType.Ellipse:
      return /* @__PURE__ */ jsx28(Ellipse3, __spreadProps(__spreadValues({}, props), { data: props.data }));
    default:
      return null;
  }
});

// src/components/context/DefaultComponentsProvider.tsx
import { Fragment as Fragment9, jsx as jsx29 } from "react/jsx-runtime";
function Container({ children }) {
  return /* @__PURE__ */ jsx29(Fragment9, { children });
}
var DefaultComponentsProvider = React11.memo(
  function DefaultComponentsProvider2({ children }) {
    return /* @__PURE__ */ jsx29(
      ComponentsProvider,
      {
        components: {
          Artboard,
          CompoundPath,
          Connector,
          Container,
          Ellipse,
          Group,
          Head,
          Interaction,
          Mask,
          Node,
          NodeList,
          Path,
          Raster,
          Rectangle,
          Shape,
          Text
        },
        children
      }
    );
  }
);

// src/components/hooks/useOverlayPortal.ts
import { overlayPortalFactory } from "@ballpark/design-core";
import {
  useOverlayPortal,
  OverlayPortalProvider,
  OverlayPortal
} from "@ballpark/design-core";
var {
  useOverlayPortal: useHtmlOverlayPortal,
  OverlayPortalProvider: HtmlOverlayPortalProvider,
  OverlayPortal: HtmlOverlayPortal
} = overlayPortalFactory();

// src/components/hooks/useShadowRoot.ts
import { createContext, useContext } from "react";
var isSSR = typeof window === "undefined";
var defaultRoot = (
  // workaround for SSR
  isSSR ? void 0 : document
);
var ShadowRootContext = createContext(
  defaultRoot
);
function useShadowRoot() {
  return useContext(ShadowRootContext);
}

// src/components/Design.tsx
import { jsx as jsx30, jsxs as jsxs12 } from "react/jsx-runtime";
var Design = observer28(function Design2({
  children,
  noShadowDom = false
  // used by screenshot tests as they can't render shadow DOM
}) {
  var _a;
  const { design, getArtboard } = useDesign7();
  const view = useView3();
  const { Container: Container2, NodeList: NodeList3 } = useComponents8();
  const [overlayPortal, setOverlayPortal] = useState(null);
  const [htmlOverlayPortal, setHtmlOverlayPortal] = useState(null);
  const [shadowRootEl, setShadowRootEl] = useState(null);
  const [width, height] = view.bounds.size;
  const RootComponent = noShadowDom ? "div" : react_shadow_esm_default.div;
  const { zoomFactor, matrix } = view;
  const offset = PointUtils7.divide(view.offset, zoomFactor);
  return /* @__PURE__ */ jsx30(ShadowRootContext.Provider, { value: (_a = shadowRootEl == null ? void 0 : shadowRootEl.shadowRoot) != null ? _a : defaultRoot, children: /* @__PURE__ */ jsx30(HtmlOverlayPortalProvider, { container: htmlOverlayPortal, children: /* @__PURE__ */ jsxs12(OverlayPortalProvider2, { container: overlayPortal, children: [
    /* @__PURE__ */ jsx30(Fonts, {}),
    /* @__PURE__ */ jsxs12(RootComponent, { "data-testid": "renderer-root", ref: setShadowRootEl, children: [
      /* @__PURE__ */ jsx30(
        "div",
        {
          style: {
            width: Math.round(width * zoomFactor),
            height: Math.round(height * zoomFactor),
            overflow: "hidden",
            position: "absolute",
            userSelect: "none",
            pointerEvents: "none"
          },
          children: /* @__PURE__ */ jsx30(
            "div",
            {
              style: {
                transform: `scale(${zoomFactor})`,
                transformOrigin: "0px 0px"
              },
              children: /* @__PURE__ */ jsx30(
                "svg",
                {
                  width: Math.round(width + 1),
                  height: Math.round(height + 1),
                  children: /* @__PURE__ */ jsx30("g", { transform: `translate(${offset.join(" ")})`, children: /* @__PURE__ */ jsxs12(Container2, { children: [
                    children,
                    /* @__PURE__ */ jsx30(ArtboardContainer, { data: getArtboard() }),
                    /* @__PURE__ */ jsx30(NodeList3, { nodes: design.root.children }),
                    /* @__PURE__ */ jsx30("g", { ref: setOverlayPortal })
                  ] }) })
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ jsx30(
        "div",
        {
          style: { transform: `matrix(${matrix.join(" ")})` },
          ref: setHtmlOverlayPortal
        }
      )
    ] })
  ] }) }) });
});
var DesignContainer = (props) => {
  return /* @__PURE__ */ jsx30(WeakViewProvider, { children: /* @__PURE__ */ jsx30(WeakFontsProvider, { children: /* @__PURE__ */ jsx30(DefaultComponentsProvider, { children: /* @__PURE__ */ jsx30(Design, __spreadValues({}, props)) }) }) });
};

// src/components/helpers/measureText.tsx
import {
  FragmentUtils,
  createEmptyDesign,
  uuid
} from "@ballpark/design-creator";
import { FontsProvider } from "@ballpark/design-plugin-fonts";
import { DesignProvider } from "@ballpark/design-plugin-react";
import { ComponentOverridesProvider } from "@ballpark/design-renderer-base";
import { useLayoutEffect, useState as useState2 } from "react";
import { createRoot } from "react-dom/client";
import { jsx as jsx31 } from "react/jsx-runtime";
function unsafeMeasureText(_0) {
  return __async(this, arguments, function* (text, fontFaces = [], timeoutMs = 5e3) {
    const container = document.createElement("div");
    const id = uuid();
    const design = createEmptyDesign();
    container.style.visibility = "hidden";
    container.style.position = "absolute";
    document.body.appendChild(container);
    FragmentUtils.mAppendItems(design, [__spreadProps(__spreadValues({}, text), { id })]);
    const root = createRoot(container);
    const size = yield new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        reject(new Error("failed to measure text in timeout"));
      }, timeoutMs);
      function MeasuredText(props) {
        const [el, setEl] = useState2(null);
        useLayoutEffect(() => {
          if (!el)
            return;
          const resizeObserver = new ResizeObserver((entries) => {
            if (!entries.length)
              return;
            const { inlineSize: width, blockSize: height } = entries[0].borderBoxSize[0];
            resolve([width, height]);
          });
          resizeObserver.observe(el);
          return () => resizeObserver.disconnect();
        }, [el]);
        return /* @__PURE__ */ jsx31(Text, __spreadProps(__spreadValues({}, props), { ref: setEl }));
      }
      root.render(
        /* @__PURE__ */ jsx31(DesignProvider, { design, children: /* @__PURE__ */ jsx31(FontsProvider, { options: { fontFaces }, children: /* @__PURE__ */ jsx31(ComponentOverridesProvider, { components: { Text: MeasuredText }, children: /* @__PURE__ */ jsx31(DesignContainer, {}) }) }) })
      );
    });
    root.unmount();
    document.body.removeChild(container);
    return size;
  });
}

// src/index.ts
import { ComponentOverridesProvider as ComponentOverridesProvider2 } from "@ballpark/design-renderer-base";
export {
  Artboard,
  ComponentOverridesProvider2 as ComponentOverridesProvider,
  CompoundPath,
  DesignContainer as Design,
  Ellipse,
  Group,
  HtmlOverlayPortal,
  HtmlOverlayPortalProvider,
  Interaction,
  Mask,
  Node,
  NodeList,
  OverlayPortal,
  OverlayPortalProvider,
  Path,
  Raster,
  Rectangle,
  Shape,
  Text,
  unsafeMeasureText,
  useHtmlOverlayPortal,
  useOverlayPortal,
  useShadowRoot
};
